<div class="popup-container d-flex flex-column">
  <label class="heading-text">
    Are you sure you want to reject this FC merge entirely?
  </label>
  <label class="content"
    >This is a critical action and cannot be reversed. Please recheck before
    proceeding!</label
  >
  @if(rejectAll){
  <div class="comment-div">
    <div class="comments d-flex justify-content-between">
      <span class="sub-heading"> Add Comments *</span>
      <!-- <span class="count">{{ count }}/120</span> -->
    </div>
    <textarea
      class="dp-input-control comment-inp"
      type="textarea"
      [formControl]="comments"
    ></textarea>
  </div>
  }
  <div class="btn-div d-flex flex-column">
    <button class="btn-content-reject" (click)="onReject()">
      <span>Yes, Reject</span>
    </button>
    <button class="dp-secondary-btn btn-content" (click)="onApproveClick()">
      <span>Approve partially</span>
    </button>
    <button class="dp-tertiary-btn btn-content" mat-dialog-close>
      No, Cancel
    </button>
  </div>
</div>
